import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import React, { useEffect, useRef, useState } from "react";
import swal from "sweetalert";
import { FaUserPlus } from "react-icons/fa";
import { get_ApiManager, post_ApiManager } from "../ApiManager/ApiManager";
import CustomPhoneInput from "../Agents/InputField";
import PermissionSwitch from "../GenericComponents/PermissionSwitches";
import TaskModalRoot from "../TaskManagement/TaskModalRoot";
import { CMS_PRIMARY } from "../TaskManagement/workspaceConstants";
import { isValidPhoneNumber } from "react-phone-number-input";
import {
  DATE_INPUT_CLASS,
  FIELD_CLASS,
  FieldError,
  INPUT_CLASS,
  LABEL_CLASS,
  SECTION_CLASS,
  calculateProbationPeriod,
  openPicker,
} from "./accountFormShared";
import "./accounts.css";

const INITIAL_FORM_STATE = {
  name: "",
  phone: "",
  branch: "",
  email: "",
  password: "",
  role: "",
  country: "",
  ipAddress: "0",
  location: "",
  ipCheck: 0,
  migAccess: 1,
  eduAccess: 1,
  aatFcctAccess: 1,
  birthdate: "",
  date_of_joining: "",
  gender: "",
  custom_checkin_time: "",
  probation_end_date: "",
  branches: [],
  notes: "",
  nameError: "",
  phoneError: "",
  emailError: "",
  dateOfJoiningError: "",
  passError: "",
  roleError: "",
  countryError: "",
  branchError: "",
  locationError: "",
  genderError: "",
  checkinTimeError: "",
  probationError: "",
  loading: false,
};

function AddAccountModal({ open, onClose, onSuccess }) {
  const scrollRef = useRef(null);
  const permissions = getPermissions() || {};
  const [state, setState] = useState(INITIAL_FORM_STATE);

  useEffect(() => {
    if (!open) return;
    setState({ ...INITIAL_FORM_STATE });
    getBranches();
  }, [open]);

  const getBranches = () => {
    get_ApiManager(
      "",
      "getBranches",
      (res) => {
        setState((prev) => ({ ...prev, branches: res.data["data"] }));
      },
      (err) => {
        console.log(err);
      },
    );
  };

  const handleCallback = (check, keyName) => {
    setState((prev) => ({
      ...prev,
      [keyName === "ip"
        ? "ipCheck"
        : keyName === "migAccess"
          ? "migAccess"
          : keyName === "eduAccess"
            ? "eduAccess"
            : "aatFcctAccess"]: check,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => {
      const newState = { ...prev, [name]: value };
      if (name === "date_of_joining" && value) {
        newState.probation_end_date = calculateProbationPeriod(value);
      }
      return newState;
    });
  };

  const handlePhoneChange = (phone) => {
    setState((prev) => ({ ...prev, phone }));
  };

  const handleValidation = () => {
    setState((prev) => ({
      ...prev,
      nameError: "",
      emailError: "",
      phoneError: "",
      passError: "",
      roleError: "",
      countryError: "",
      branchError: "",
      locationError: "",
      dateOfJoiningError: "",
      genderError: "",
      checkinTimeError: "",
      probationError: "",
    }));

    if (!state.name) {
      scrollRef.current?.scrollIntoView({ behavior: "smooth" });
      setState((prev) => ({ ...prev, nameError: "Please enter full name" }));
      return false;
    }

    if (!isValidPhoneNumber(state.phone)) {
      setState((prev) => ({ ...prev, phoneError: "Invalid Phone Number" }));
      return false;
    }

    const emailPattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/i;

    if (!state.date_of_joining) {
      setState((prev) => ({
        ...prev,
        dateOfJoiningError: "Please enter date of joining",
      }));
      return false;
    }
    if (!state.gender) {
      setState((prev) => ({ ...prev, genderError: "Please select gender" }));
      return false;
    }

    if (!state.email) {
      setState((prev) => ({ ...prev, emailError: "Please enter email" }));
      return false;
    }
    if (!emailPattern.test(state.email)) {
      setState((prev) => ({
        ...prev,
        emailError: "Please enter correct email",
      }));
      return false;
    }
    if (!state.password) {
      setState((prev) => ({ ...prev, passError: "Please enter password" }));
      return false;
    }
    if (state.password.length < 6) {
      setState((prev) => ({
        ...prev,
        passError: "Password must be at least 6 characters",
      }));
      return false;
    }
    if (!state.role) {
      setState((prev) => ({ ...prev, roleError: "Please select role" }));
      return false;
    }
    if (!state.country) {
      setState((prev) => ({ ...prev, countryError: "Please select country" }));
      return false;
    }
    if (!state.branch) {
      setState((prev) => ({ ...prev, branchError: "Please select branch" }));
      return false;
    }
    if (!state.location) {
      setState((prev) => ({
        ...prev,
        locationError: "Please select location",
      }));
      return false;
    }

    if (!state.probation_end_date) {
      setState((prev) => ({
        ...prev,
        probationError: "Please enter probation period end date",
      }));
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!handleValidation()) return;

    const data = {
      name: state.name,
      phone: state.phone,
      email: state.email,
      password: state.password,
      role: state.role,
      country: state.country,
      branch: state.branch,
      branch_id: state.branch,
      allow_ip: state.ipCheck,
      ip_address: state.ipAddress,
      mig_access: state.migAccess,
      edu_access: state.eduAccess,
      aat_access: state.aatFcctAccess,
      location: state.location,
      birthdate: state.birthdate,
      notes: state.notes,
      date_of_joining: state.date_of_joining,
      gender: state.gender,
      custom_checkin_time: state.custom_checkin_time,
      probation_end_date: state.probation_end_date,
    };

    setState((prev) => ({ ...prev, loading: true }));
    post_ApiManager(
      data,
      "addUser",
      (res) => {
        setState((prev) => ({ ...prev, loading: false }));
        if (res.data.error) {
          swal(" ", res.data.error, "error");
        } else {
          swal("Success!", "New User Created Successfully!", "success");
          onSuccess?.();
          onClose?.();
        }
      },
      (err) => {
        console.log(err);
        setState((prev) => ({ ...prev, loading: false }));
      },
    );
  };

  if (!open || permissions.accounts !== 1) return null;

  return (
    <TaskModalRoot open={open}>
      <div className="add-account-modal-shell relative z-10 rounded-2xl border border-[#E5E7EB] bg-white shadow-2xl">
        <div className="add-account-modal-header relative border-b border-gray-100 px-5 py-4">
          <div
            className="absolute inset-x-0 top-0 h-[3px] rounded-t-2xl"
            style={{ backgroundColor: CMS_PRIMARY }}
          />
          <div className="flex items-start justify-between gap-4">
            <div className="flex min-w-0 items-start gap-3">
              <div
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-white shadow-sm"
                style={{ backgroundColor: CMS_PRIMARY }}
              >
                <FaUserPlus size={16} />
              </div>
              <div className="min-w-0">
                <h2 className="text-base font-bold text-[#35314d] sm:text-lg">
                  Create New Employee Account
                </h2>
                <p className="mt-0.5 text-xs text-gray-500">
                  Add employee details, access permissions, and branch assignment
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={onClose}
              disabled={state.loading}
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-gray-400 transition hover:bg-gray-100 hover:text-gray-600 disabled:opacity-50"
              aria-label="Close"
            >
              ✕
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="add-account-modal-form">
          <div ref={scrollRef} className="add-account-modal-body">
            <div className="add-account-form-grid">
              <div className={FIELD_CLASS}>
                <label htmlFor="add-name" className={LABEL_CLASS}>
                  Full Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  className={`${INPUT_CLASS} ${state.nameError ? "border-red-300 focus:border-red-400 focus:ring-red-200" : ""}`}
                  id="add-name"
                  name="name"
                  value={state.name}
                  onChange={handleChange}
                  placeholder="Enter full name"
                  disabled={state.loading}
                />
                <FieldError message={state.nameError} />
              </div>

              <div className={`${FIELD_CLASS} add-account-phone-field`}>
                <CustomPhoneInput
                  value={state.phone}
                  onChange={handlePhoneChange}
                  name="phone"
                  error={state.phoneError}
                  placeholder="Enter phone number"
                  defaultCountry="PK"
                  required
                  label="Phone"
                />
              </div>

              <div className={FIELD_CLASS}>
                <label htmlFor="add-birthdate" className={LABEL_CLASS}>
                  Date of Birth
                </label>
                <input
                  type="date"
                  className={DATE_INPUT_CLASS}
                  id="add-birthdate"
                  name="birthdate"
                  value={state.birthdate}
                  onChange={handleChange}
                  onClick={openPicker}
                  onFocus={openPicker}
                  disabled={state.loading}
                />
              </div>

              <div className={FIELD_CLASS}>
                <label htmlFor="add-date_of_joining" className={LABEL_CLASS}>
                  Date of Joining <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  className={`${DATE_INPUT_CLASS} ${state.dateOfJoiningError ? "border-red-300 focus:border-red-400 focus:ring-red-200" : ""}`}
                  id="add-date_of_joining"
                  name="date_of_joining"
                  value={state.date_of_joining}
                  onChange={handleChange}
                  onClick={openPicker}
                  onFocus={openPicker}
                  disabled={state.loading}
                />
                <FieldError message={state.dateOfJoiningError} />
              </div>

              <div className={FIELD_CLASS}>
                <label htmlFor="add-probation_end_date" className={LABEL_CLASS}>
                  Probation Period End <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  className={`${DATE_INPUT_CLASS} ${state.probationError ? "border-red-300 focus:border-red-400 focus:ring-red-200" : ""}`}
                  id="add-probation_end_date"
                  name="probation_end_date"
                  value={state.probation_end_date}
                  onChange={handleChange}
                  onClick={openPicker}
                  onFocus={openPicker}
                  disabled={state.loading}
                />
                <FieldError message={state.probationError} />
              </div>

              <div className={FIELD_CLASS}>
                <label htmlFor="add-gender" className={LABEL_CLASS}>
                  Gender <span className="text-red-500">*</span>
                </label>
                <select
                  id="add-gender"
                  className={`${INPUT_CLASS} ${state.genderError ? "border-red-300 focus:border-red-400 focus:ring-red-200" : ""}`}
                  name="gender"
                  value={state.gender}
                  onChange={handleChange}
                  disabled={state.loading}
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
                <FieldError message={state.genderError} />
              </div>

              <div className={FIELD_CLASS}>
                <label htmlFor="add-custom_checkin_time" className={LABEL_CLASS}>
                  Custom Check-in Time
                </label>
                <input
                  type="time"
                  className={`${DATE_INPUT_CLASS} ${state.checkinTimeError ? "border-red-300 focus:border-red-400 focus:ring-red-200" : ""}`}
                  id="add-custom_checkin_time"
                  name="custom_checkin_time"
                  value={state.custom_checkin_time}
                  onChange={handleChange}
                  onClick={openPicker}
                  onFocus={openPicker}
                  disabled={state.loading}
                />
                <FieldError message={state.checkinTimeError} />
              </div>

              <div className={FIELD_CLASS}>
                <label htmlFor="add-email" className={LABEL_CLASS}>
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  className={`${INPUT_CLASS} ${state.emailError ? "border-red-300 focus:border-red-400 focus:ring-red-200" : ""}`}
                  id="add-email"
                  name="email"
                  value={state.email}
                  onChange={handleChange}
                  placeholder="Enter email"
                  disabled={state.loading}
                />
                <FieldError message={state.emailError} />
              </div>

              <div className={FIELD_CLASS}>
                <label htmlFor="add-password" className={LABEL_CLASS}>
                  Password <span className="text-red-500">*</span>
                </label>
                <input
                  type="password"
                  className={`${INPUT_CLASS} ${state.passError ? "border-red-300 focus:border-red-400 focus:ring-red-200" : ""}`}
                  id="add-password"
                  name="password"
                  value={state.password}
                  onChange={handleChange}
                  placeholder="Enter password"
                  disabled={state.loading}
                />
                <FieldError message={state.passError} />
              </div>

              <div className={FIELD_CLASS}>
                <label htmlFor="add-role" className={LABEL_CLASS}>
                  User Role <span className="text-red-500">*</span>
                </label>
                <select
                  id="add-role"
                  className={`${INPUT_CLASS} ${state.roleError ? "border-red-300 focus:border-red-400 focus:ring-red-200" : ""}`}
                  name="role"
                  value={state.role}
                  onChange={handleChange}
                  disabled={state.loading}
                >
                  <option value="">Select Role</option>
                  <option value="0">Admin</option>
                  <option value="2">Super Admin</option>
                  <option value="1">User</option>
                </select>
                <FieldError message={state.roleError} />
              </div>

              <div className={FIELD_CLASS}>
                <label htmlFor="add-country" className={LABEL_CLASS}>
                  Country <span className="text-red-500">*</span>
                </label>
                <select
                  className={`${INPUT_CLASS} ${state.countryError ? "border-red-300 focus:border-red-400 focus:ring-red-200" : ""}`}
                  id="add-country"
                  name="country"
                  value={state.country}
                  onChange={handleChange}
                  disabled={state.loading}
                >
                  <option value="">Select Country</option>
                  <option value="Australia">Australia</option>
                  <option value="Pakistan">Pakistan</option>
                  <option value="Other">Other</option>
                </select>
                <FieldError message={state.countryError} />
              </div>

              <div className={FIELD_CLASS}>
                <label htmlFor="add-branch" className={LABEL_CLASS}>
                  Branch <span className="text-red-500">*</span>
                </label>
                <select
                  className={`${INPUT_CLASS} ${state.branchError ? "border-red-300 focus:border-red-400 focus:ring-red-200" : ""}`}
                  id="add-branch"
                  name="branch"
                  value={state.branch}
                  onChange={handleChange}
                  disabled={state.loading}
                >
                  <option value="">Select Branch</option>
                  {state.branches
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((value) => (
                      <option key={value.id} value={value.id}>
                        {value.name}
                      </option>
                    ))}
                </select>
                <FieldError message={state.branchError} />
              </div>

              <div className={FIELD_CLASS}>
                <label htmlFor="add-location" className={LABEL_CLASS}>
                  Location <span className="text-red-500">*</span>
                </label>
                <select
                  className={`${INPUT_CLASS} ${state.locationError ? "border-red-300 focus:border-red-400 focus:ring-red-200" : ""}`}
                  id="add-location"
                  name="location"
                  value={state.location}
                  onChange={handleChange}
                  disabled={state.loading}
                >
                  <option value="">Select Location</option>
                  <option value="Onshore">Onshore</option>
                  <option value="Offshore">Offshore</option>
                </select>
                <FieldError message={state.locationError} />
              </div>

              <div className="add-account-field-full">
                <label htmlFor="add-notes" className={LABEL_CLASS}>
                  Description
                </label>
                <textarea
                  className={`${INPUT_CLASS} min-h-[96px] py-2.5`}
                  id="add-notes"
                  name="notes"
                  value={state.notes}
                  onChange={handleChange}
                  rows={3}
                  placeholder="Enter description"
                  disabled={state.loading}
                />
              </div>
            </div>

            <div className="add-account-permissions-section">
              <p className="add-account-section-title">Access & Permissions</p>
              <div className="add-account-permissions-grid">
                <div className="add-account-permission-item">
                  <span>Allow IP</span>
                  <PermissionSwitch
                    generic={true}
                    keyName="ip"
                    status={state.ipCheck}
                    parentCallback={handleCallback}
                  />
                </div>
                <div className="add-account-permission-item">
                  <span>Migration</span>
                  <PermissionSwitch
                    generic={true}
                    keyName="migAccess"
                    status={state.migAccess}
                    parentCallback={handleCallback}
                  />
                </div>
                <div className="add-account-permission-item">
                  <span>Education</span>
                  <PermissionSwitch
                    generic={true}
                    keyName="eduAccess"
                    status={state.eduAccess}
                    parentCallback={handleCallback}
                  />
                </div>
                <div className="add-account-permission-item">
                  <span>AAT/FCCT</span>
                  <PermissionSwitch
                    generic={true}
                    keyName="aat/fcct"
                    status={state.aatFcctAccess}
                    parentCallback={handleCallback}
                  />
                </div>
              </div>

              {state.ipCheck ? (
                <div className="add-account-permission-ip">
                  <label htmlFor="add-ipAddress" className={LABEL_CLASS}>
                    IP Address
                  </label>
                  <input
                    type="text"
                    className={INPUT_CLASS}
                    id="add-ipAddress"
                    name="ipAddress"
                    value={state.ipAddress}
                    onChange={handleChange}
                    placeholder="Enter IP addresses"
                    disabled={state.loading}
                  />
                  <p className="mt-1 text-xs text-gray-500">
                    Add multiple addresses separated by commas
                  </p>
                </div>
              ) : null}
            </div>
          </div>

          <div className="add-account-modal-footer flex items-center justify-end gap-2 border-t border-gray-100 bg-[#FAFBFC] px-5 py-3">
            <button
              type="button"
              onClick={onClose}
              disabled={state.loading}
              className="inline-flex h-10 items-center rounded-lg border border-[#E5E7EB] bg-white px-4 text-sm font-medium text-gray-600 shadow-sm transition hover:border-gray-300 hover:bg-gray-50 disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={state.loading}
              className="inline-flex h-10 items-center gap-2 rounded-lg px-5 text-sm font-semibold text-white shadow-md transition hover:brightness-95 disabled:opacity-70"
              style={{
                backgroundColor: CMS_PRIMARY,
                boxShadow: "0 2px 8px rgba(0, 123, 255, 0.28)",
              }}
            >
              {state.loading ? (
                <>
                  <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white" />
                  Creating...
                </>
              ) : (
                "Create Account"
              )}
            </button>
          </div>
        </form>
      </div>
    </TaskModalRoot>
  );
}

export default AddAccountModal;
